import { environment } from 'src/environments/environment';
import { TreeNode } from "ui-library";

export const MainMenu: TreeNode[] = [
    {
        name: 'projects.title',
        translate: "projects.title",
        route: '',
        icon: "source",
        role: ["admin", "dev", "guest", "user", "userAdmin"],
        isOpen: false,
        children: [
            {
                name: 'projects.recents',
                translate: "projects.recents",
                divide: true,
                icon: "history",
                role: ["admin", "dev", "guest", "user", "userAdmin"],
                children: []
            },
            {
                name: 'projects.allProjects',
                translate: "projects.allProjects",
                route: '/projects',
                divide: true,
                icon: "source",
                role: ["admin", "dev", "guest", "user", "userAdmin"]
            },
            {
                name: 'projects.addProject',
                translate: "projects.addProject",
                route: '/project-detail',
                icon: "add_circle",
                role: ["admin", "dev", "userAdmin"]
            }
        ]
    },
    {
        name: 'synthesis.title',
        translate: "synthesis.title",
        route: '/synthesis',
        icon: "insights",
        role: ["admin", "dev", "user", "userAdmin"]
    },
    {
        name: 'trackers.title',
        translate: "trackers.title",
        route: '/devices',
        icon: "track_changes",
        role: ["admin", "dev", "user", "userAdmin"],
        children: []
    },
    {
        name: 'users.title',
        translate: "users.title",
        route: '',
        icon: "people",
        role: ["admin", "dev", "userAdmin"],
        isOpen: false,
        children: [
            {
                name: 'users.registry',
                translate: "users.registry",
                route: '/users/registry',
                icon: "manage_accounts",
                role: ["admin", "dev", "userAdmin"]
            },
            {
                name: 'users.add_user',
                translate: "users.add_user",
                route: '/users/edit-user',
                icon: "person_add",
                role: ["admin", "dev", "userAdmin"]
            },
            {
                name: 'users.access_management',
                translate: "users.access_management",
                route: '/users/accesses',
                icon: "vpn_key",
                role: ["admin", "dev"]
            }
        ]
    },
    // {
    //     name: 'workflows.title',
    //     translate: "workflows.title",
    //     route: '/workflows-master',
    //     icon: "share",
    //     role: ["admin", "dev"],
    //     children: []
    // },
    {
        name: 'admin.title',
        translate: "admin.title",
        route: '',
        icon: "admin_panel_settings",
        role: ["admin", "dev"],
        isOpen: false,
        children: [
            {
                name: 'interventions.title',
                translate: "interventions.title",
                route: '/admin/all-interventions',
                icon: "engineering",
                role: ["admin", "dev"]
            },
            {
                name: 'companies.title',
                translate: "companies.title",
                route: '/admin/companies',
                icon: "domain",
                role: ["admin", "dev"]
            },
            {
                name: 'admin.template_config',
                translate: "admin.template_config",
                route: '/service-config',
                icon: "tune",
                role: ["admin", "dev"]
            },
            {
                name: 'Portail Z42',
                translate: "Portail Z42",
                url: 'https://security42.francecentral.cloudapp.azure.com/',
                svgIcon: "z42", // logo Z42 vectorisé, monochrome (currentColor)
                role: ["admin", "dev"]
            },
        ]
    },
    {
        name: 'support.help',
        translate: "support.title",
        route: '',
        icon: "help",
        role: ["admin", "dev", "guest", "user", "userAdmin"],
        isOpen: false,
        children: [
            // {
            //     name: 'Sauron',
            //     translate: "Sauron",
            //     url: 'https://audit.dev.cad42.com',
            //     icon: "visibility", // Sauron = œil (surveillance)
            //     role: ["admin", "dev"]
            // },
            {
                name: 'support.doc',
                translate: "support.doc",
                url: 'https://cad42.atlassian.net/wiki/x/HoFC',
                icon: "description", // Documentation = document
                role: ["admin", "dev", "guest", "user", "userAdmin"]
            },
            {
                name: 'support.api',
                translate: "support.api",
                url: 'https://doc.dev.cad42.com/',
                icon: "description", // Documentation = document
                role: ["admin", "dev", "guest", "user", "userAdmin"]
            },
            {
                name: 'support.title',
                translate: "support.title",
                url: 'https://cad42.atlassian.net/servicedesk/customer/portals',
                icon: "support_agent", // Support client = agent de support
                role: ["admin", "dev", "guest", "user", "userAdmin"]
            },
            // {
            //     name: 'title.contact-us',
            //     translate: "title.contact-us",
            //     route: '/contact-us',
            //     icon: "contact_mail", // Contact = courrier
            //     role: ["admin", "dev", "guest", "user", "userAdmin"]
            // },
            {
                name: 'Version : ' + environment.version,
                translate: 'Version : ' + environment.version,
                route: '/',
                icon: "", // Contact = courrier
                role: ["admin", "dev", "guest", "user", "userAdmin"]
            }
        ]
    }
];
